module.exports = __webpack_public_path__ + "img/newchris-26.2e3b818d.jpg";